var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6087 14.8704V3.19111C10.6087 2.80392 10.4604 2.43259 10.1965 2.1588C9.93253 1.88501 9.57455 1.7312 9.20128 1.7312H6.38647C6.0132 1.7312 5.65522 1.88501 5.39128 2.1588C5.12734 2.43259 4.97906 2.80392 4.97906 3.19111V14.8704M2.16424 4.65102H13.4235C14.2008 4.65102 14.8309 5.30465 14.8309 6.11093V13.4105C14.8309 14.2168 14.2008 14.8704 13.4235 14.8704H2.16424C1.38695 14.8704 0.756836 14.2168 0.756836 13.4105V6.11093C0.756836 5.30465 1.38695 4.65102 2.16424 4.65102Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagIcon);
export default __webpack_public_path__ + "static/media/bag-icon.85dcf88a3cda0f64a4e7c171392d7c56.svg";
export { ForwardRef as ReactComponent };